export default __webpack_public_path__ + "static/media/UserSettingsIcon.da16eeaa.svg";